import { render, staticRenderFns } from "./PersonalDataFinancialSponsorForm.vue?vue&type=template&id=258be298&scoped=true&"
import script from "./PersonalDataFinancialSponsorForm.vue?vue&type=script&lang=ts&"
export * from "./PersonalDataFinancialSponsorForm.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalDataFinancialSponsorForm.vue?vue&type=style&index=0&id=258be298&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258be298",
  null
  
)

export default component.exports